module.exports = __webpack_public_path__ + "static/media/DownloadIconBlue.95b7c634.svg";